export default __webpack_public_path__ + "static/char-s-05-kr-808dc7bf596d9c46fb1fbf231b519cfc.webp";